module.exports = __webpack_public_path__ + "static/media/icon-decending.63c1a113.svg";